import React, { useState, useEffect } from 'react';
import PageNumberButton from '../PageNumberButton/PageNumberButton';
import { VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY, VIDEO_SEARCH_API_LIMIT } from "../../../constant"


const SearchUploadedVideoPagination = ({ totalNumberofPages, currentPage, onPageChange }) => {
    const [startPageNo, setStartPageNo] = useState(0);


    // Calculate skip value for internal use
    const skip = (currentPage - 1) * VIDEO_SEARCH_API_LIMIT;

    // Update start page number based on current page
    useEffect(() => {
        if (currentPage === totalNumberofPages) {
            setStartPageNo(
                totalNumberofPages >= VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY
                    ? totalNumberofPages - VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY
                    : 0
            );
        } else if (currentPage === 1) {
            setStartPageNo(0);
        }
    }, [currentPage, totalNumberofPages]);

    // Handle previous page
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newPage = currentPage - 1;
            const newSkip = (newPage - 1) * VIDEO_SEARCH_API_LIMIT;

            console.log(`⬅️ Previous page: ${currentPage} → ${newPage}`);
            onPageChange(newPage);

        }
    };

    // Handle next page
    const handleNextPage = () => {
        if (currentPage < totalNumberofPages) {
            const newPage = currentPage + 1;
            const newSkip = (newPage - 1) * VIDEO_SEARCH_API_LIMIT;

            console.log(`➡️ Next page: ${currentPage} → ${newPage}`);
            onPageChange(newPage);
        }
    };

    // Handle specific page click
    const handlePageClick = (pageNumber) => {
        if (pageNumber !== currentPage) {
            console.log(`📄 Page clicked: ${currentPage} → ${pageNumber}`);
            onPageChange(pageNumber);
        }
    };

    return (
        <div className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-2 my-8 px-2 sm:px-4">
            {/* Previous Button */}
            <button
                onClick={handlePreviousPage}
                disabled={currentPage <= 1}
                title="Previous page"
                className={`
                    flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-lg font-semibold text-base sm:text-lg transition-all duration-200
                    ${currentPage > 1
                        ? 'bg-white border border-slate-200 text-slate-700 hover:bg-gradient-to-r hover:from-[#247E45] hover:to-[#026B33] hover:text-white hover:border-transparent hover:shadow-lg hover:shadow-emerald-500/20 cursor-pointer'
                        : 'bg-slate-100 border border-slate-200 text-slate-400 cursor-not-allowed'
                    }
                `}
            >
                ❮
            </button>

            {/* First Page */}
            {startPageNo + 1 > 1 && (
                <PageNumberButton
                    key={1}
                    pageNumber={1}
                    isSelected={currentPage === 1}
                    onClick={() => handlePageClick(1)}
                />
            )}

            {/* Ellipsis before */}
            {startPageNo + 1 > 1 && (
                <p className="px-2 text-slate-400 font-medium select-none">. . .</p>
            )}

            {/* Page Numbers */}
            {Array.from(
                {
                    length: totalNumberofPages < VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY
                        ? totalNumberofPages
                        : VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY
                },
                (_, index) => {
                    const pageNumber = startPageNo + index + 1;
                    return (
                        <PageNumberButton
                            key={pageNumber}
                            pageNumber={pageNumber}
                            isSelected={currentPage === pageNumber}
                            onClick={() => handlePageClick(pageNumber)}
                        />
                    );
                }
            )}

            {/* Ellipsis after */}
            {startPageNo < totalNumberofPages - VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY && (
                <p className="px-2 text-slate-400 font-medium select-none">. . .</p>
            )}

            {/* Last Page */}
            {startPageNo < totalNumberofPages - VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY && (
                <PageNumberButton
                    key={totalNumberofPages}
                    pageNumber={totalNumberofPages}
                    isSelected={currentPage === totalNumberofPages}
                    onClick={() => handlePageClick(totalNumberofPages)}
                />
            )}

            {/* Next Button */}
            <button
                onClick={handleNextPage}
                disabled={currentPage >= totalNumberofPages}
                title="Next page"
                className={`
                    flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-lg font-semibold text-base sm:text-lg transition-all duration-200
                    ${currentPage < totalNumberofPages
                        ? 'bg-white border border-slate-200 text-slate-700 hover:bg-gradient-to-r hover:from-[#247E45] hover:to-[#026B33] hover:text-white hover:border-transparent hover:shadow-lg hover:shadow-emerald-500/20 cursor-pointer'
                        : 'bg-slate-100 border border-slate-200 text-slate-400 cursor-not-allowed'
                    }
                `}
            >
                ❯
            </button>
        </div>
    );

};

export default SearchUploadedVideoPagination;
